import Charities from './Charities';

export default Charities;
